import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SBack } from '@/components/ui/molecules/SBack';
import { ThemeToggle } from '@/components/ui/atoms/ThemeToggle';
import { MapPin } from 'phosphor-react';
import ordersService from '@/services/orders.service';
import { OrderResponse } from '@/types/order.types';
import { useUserLocation } from '@/hooks/useUserLocation';
import './OrderDetails.css';

function fmtAmount(n: number): string {
  return `$${n.toFixed(2)}`;
}

const OrderDetails: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [order, setOrder] = useState<OrderResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { location: userLocation } = useUserLocation();

  useEffect(() => {
    if (!id) return;
    ordersService.getOrderById(id)
      .then(setOrder)
      .catch(e => console.error(e))
      .finally(() => setIsLoading(false));
  }, [id]);

  const locationName = userLocation?.name || 'Tee Box';
  const itemTotal = order?.items.reduce((s, i) => s + i.price * i.quantity, 0) ?? 0;

  return (
    <div className="od">
      <div className="od__header">
        <SBack onClick={() => navigate(-1)} />
        <span className="od__title">Order Details</span>
        <ThemeToggle />
      </div>

      {isLoading ? (
        <div className="od__loading">Loading…</div>
      ) : !order ? (
        <div className="od__loading">Order not found</div>
      ) : (
        <div className="od__body">

          {/* Order info */}
          <div>
            <p className="od__section-label">
              #{order.orderId || order.id.slice(-6).toUpperCase()}
            </p>
            <div className="od__card">
              <div className="od__location-row">
                <div className="od__location-chip">
                  <MapPin size={12} color="#9e9a90" weight="fill" />
                  <span className="od__location-text">Tee Box · {locationName}</span>
                </div>
                <span className="od__badge">Paid</span>
              </div>
              <div className="od__divider" />
              <div className="od__items">
                {order.items.map((item, i) => (
                  <div key={i} className="od__item">
                    <span className="od__item-name">{item.name}</span>
                    <span className="od__item-qty">×{item.quantity}</span>
                    <span className="od__item-price">{fmtAmount(item.price)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Bill */}
          <div>
            <p className="od__section-label">Bill Details</p>
            <div className="od__card">
              <div className="od__bill-row">
                <span className="od__bill-label">Item Total</span>
                <span className="od__bill-value">{fmtAmount(itemTotal)}</span>
              </div>
              <div className="od__divider" />
              <div className="od__bill-row">
                <span className="od__bill-label od__bill-label--strong">Total</span>
                <span className="od__bill-value od__bill-value--strong">{fmtAmount(itemTotal)}</span>
              </div>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default OrderDetails;
